// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        suggestionMobileStyle: 'style1',
      enableSearch: true,
		enableSuggestion: true,
    }
};

// Override Settings
(function () {  // Add this
  BoostPFS.inject(this);  // Add this

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
  };
  InstantSearchMobile.prototype.afterBindEvents = function() {
    var self = this;

    jQ('.header__action-item-link[data-action="toggle-search"]').off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ('.search-bar__input').focus();
      self.openSuggestionMobile();
    });

  }
  InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function(isClose) {
    //Fix conflict with theme search
    jQ('.header__search-bar-wrapper').removeClass('is-visible');
    jQ('header.header.header--inline').removeClass('header--search-expanded');
  }

 //  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
	// 	// If the multi-currency feature is enabled, update the product price
	// 	this.prepareSuggestionProductPriceData();
 //        // Check from price
 //        var priceVaries = this.data.price_min != this.data.price_max;
	// 	// Check on sale
	// 	var onSale = this.data.variants[0].compare_at_price > this.data.variants[0].price;
	// 	// Format price
	// 	var price = Utils.formatMoney(parseFloat(this.data.variants[0].price));

 //        if(priceVaries){
 //            // Get min price from availalbe variant
 //            var dataPriceMinAvailable = this.data.price_max;
 //            var dataVariants = this.data.variants;
 //            for(var i = 0; i < dataVariants.length; i++){
 //              if(dataVariants[i].available && dataPriceMinAvailable > dataVariants[i].price){
 //                dataPriceMinAvailable = parseFloat(dataVariants[i].price);
 //              }
 //            }
 //            price = Utils.formatMoney(dataPriceMinAvailable);
 //        }
    
	// 	var compareAtPrice = '';
	// 	if (this.data && this.data.variants[0].compare_at_price) {
	// 		compareAtPrice = Utils.formatMoney(parseFloat(this.data.variants[0].compare_at_price));
	// 		if (Settings.getSettingValue('search.removePriceDecimal')) {
	// 			price = Utils.removeDecimal(price);
	// 			compareAtPrice = Utils.removeDecimal(compareAtPrice);
	// 		}
	// 	}

 //        if(Shopify.country == 'SE' || Shopify.country == 'SEK'){
 //          price = price.replace(/,/g, ' ');
 //          compareAtPrice = compareAtPrice.replace(/,/g, ' ');
 //        }
		
	// 	// Build Price
	// 	var result = '';
	// 	if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
	// 		if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
	// 			result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
	// 		} else {
	// 			result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
	// 		}
	// 	}
        
 //        if(!priceVaries){
 //          return result
	// 		.replace(/{{regularPrice}}/g, price)
	// 		.replace(/{{compareAtPrice}}/g, compareAtPrice);
 //        }else{
 //          return result
	// 		.replace(/{{regularPrice}}/g, boostPFSConfig.label.from.replace(/{{price_min}}/g, price))
	// 		.replace(/{{compareAtPrice}}/g, compareAtPrice);
 //        }
	// }
// Start boost 205113
  InstantSearchResultItemProduct.prototype.afterRender = function() {
    if (this.hasOwnProperty('data') && this.data !== null) {
        var data = this.data;

        var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
        var localeURLPart = "";

        if (hasShopifyRoutes) {
            localeURLPart = Shopify.routes.root.replace(/\/$/, '');
        }

        var quickUrl = localeURLPart + '/products/' + data.handle + '?view=boost-pfs-price';
        jQ('.boost-pfs-search-suggestion-item[data-id="' + data.id + '"] .boost-pfs-search-suggestion-product-price').empty();
        jQ.ajax({
            url: quickUrl,
            success: function(result) {
                try {
                    jQ('.boost-pfs-search-suggestion-item[data-id="' + data.id + '"] .boost-pfs-search-suggestion-product-price').html(result.trim());
                } catch (error) {
                    console.log(error);
                }
            }
        });
    }
}
 // Start boost 205113 

})();  // Add this at the end